import { render, staticRenderFns } from "./filter-toggle.vue?vue&type=template&id=47af0147&scoped=true&"
import script from "./filter-toggle.vue?vue&type=script&lang=js&"
export * from "./filter-toggle.vue?vue&type=script&lang=js&"
import style0 from "./filter-toggle.vue?vue&type=style&index=0&id=47af0147&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47af0147",
  null
  
)

export default component.exports